import { render, staticRenderFns } from "./PassiveTicketList.vue?vue&type=template&id=2703cde0"
import script from "./PassiveTicketList.vue?vue&type=script&lang=js"
export * from "./PassiveTicketList.vue?vue&type=script&lang=js"
import style0 from "./PassiveTicketList.vue?vue&type=style&index=0&id=2703cde0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports